<template>
	<div
		v-if="isBlockShown"
		:class="['panel',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div class="row">
				<div
					:class="[
						'col-12',
						isRightColumn? 'col-lg-12' : 'col-lg-6',
					]"
				>
					<div
						class="border-lg-bottom h-100 d-flex justify-content-center flex-column py-4 pr-lg-5 border-lg-top"
					>
						<div
							v-if="isHeaderVisible"
							:class="[
								'panel_header',
								isBrand? 'sk' : '',
							]"
						>
							<h2>
								{{ block.block_title }}
							</h2>
						</div>
						<div v-if="block.description" class="title">
							{{ block.description }}
						</div>
						<div v-if="block.text" v-html="block.text" />
					</div>
				</div>

				<div
					v-show="!isRightColumn"
					class="col-12 col-lg-6"
				>
					<div class="row h-100">
						<div class="col-12 col-sm-7 col-md-6 col-lg-7 order-sm-2">
							<div
								:class="['event_brief_image',
									block.image_appearance? block.image_appearance : ''
								]"
							>
								<img class="responsive" :src="block.image">
							</div>
						</div>
						<div class="col-12 col-sm-5 col-md-6 col-lg-5 order-sm-1">
							<div class="event_brief py-4">
								<div v-if="block.center_column_title" class="title">
									{{ block.center_column_title }}
								</div>
								<parse-snippets :content="block.center_column_buttons" />
							</div>
						</div>
					</div>
				</div>

				<div v-if="block.bottom_buttons" class="col-12 col-lg-12">
					<div class="bottom-control mt-4">
						<parse-snippets :content="block.bottom_buttons" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ParseSnippets from '~/components/snippets/ParseSnippets.vue';
import panel from '~/mixins/panel';
import checkIsBlockShown from '~/mixins/checkIsBlockShown';

export default {
	name: 'PanelTe04',
	components: {
		ParseSnippets,
	},
	mixins: [panel, checkIsBlockShown],
	computed: {
		isRightColumn() {
			return this.block.right_column_disable === true;
		},
	},
};
</script>

<style lang="scss" scoped>
	@import 'assets/styles/sk_variables';
	// For use bootstrap vars and mixins inside
	@import "assets/styles/bootstrap/scss/functions";
	@import "assets/styles/bootstrap/scss/variables";
	@import "assets/styles/bootstrap/scss/mixins";

	@import "~/assets/styles/components/home/panel-about_program";

	.event_brief_image {
		padding: 0;
	}

	.event_brief {
		justify-content: flex-end;
	}

	.event_overview {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		border-top: 0;
		// border-bottom: 1px solid;
		height: 100%;
		padding: 0 0 2rem 0;

		.title {
			margin-bottom: 0;
		}

		h2 {
			font-size: 2.5rem;
			line-height: 1;
			font-weight: bold;
			margin-bottom: 1rem;
		}
	}
</style>
